import { default as MuiTableBody } from '@mui/material/TableBody';

/**
 * TableBody contains the data rows of a Table.
 *
 * Demos:
 *
 * - [Table](https://unify.workiva.org/components/table?tab=code)
 *
 * API:
 *
 * - [TableBody API](https://unify.workiva.org/components/table?tab=props#tablebody)
 */
export const TableBody = MuiTableBody;
export { type TableBodyProps, tableBodyClasses } from '@mui/material/TableBody';
